"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Rectangle {
    constructor(left, top, width, height) {
        this.left = left;
        this.top = top;
        this.width = width;
        this.height = height;
    }
    get bottom() {
        return this.top + this.height;
    }
    get right() {
        return this.left + this.width;
    }
    /**
     * Calculate the intersection of both rectangles and return the position and width+height of the overlap
     */
    intersect(rect) {
        const left = Math.max(this.left, rect.left);
        const top = Math.max(this.top, rect.top);
        const width = Math.max(0, Math.min(this.left + this.width, rect.left + rect.width) - left);
        const height = Math.max(0, Math.min(this.top + this.height, rect.top + rect.height) - top);
        // no overlap
        if (width === 0 || height === 0) {
            return null;
        }
        return new Rectangle(left, top, width, height);
    }
    /**
     * Determine if `rect` is everywhere inside this rectangle
     */
    contains(rect) {
        // point is to the left or above the viewport
        if (rect.left < this.left || rect.top < this.top) {
            return false;
        }
        // point is outside the right side of the viewport
        if (rect.left + rect.width > this.width + this.left) {
            return false;
        }
        // point is outside the bottom side of the viewport
        return rect.top + rect.height <= this.height + this.top;
    }
    /**
     * Move the given rectangle to the given point
     */
    translate(point) {
        return new Rectangle(point.x, point.y, this.width, this.height);
    }
}
exports.default = Rectangle;
//# sourceMappingURL=Rectangle.js.map